import { env } from 'src/env.mjs'
import { Language } from '../../config/Languages'

type Attachment = {
  attachmentUri: string
  id: string
  title: string
}

export const getContentForId = async ({
  lang,
  treeId,
}: {
  treeId: string
  lang: Language
}) => {
  const res = await fetch(
    `${env.NEXT_PUBLIC_API_URL}/sabio/searchLeaf?lang=${lang}&leafId=${treeId}`,
  )
  const json = await res.json()
  return json as Promise<{
    path: any[]
    score: number
    resource: string
    created: string
    'path.id': string[]
    path_ids: string[]
    lastUpdate: string
    id: string
    title: string
    excerpt: string
    'path.title': string[]
    attachments: Attachment[]
    content: [string]
  }>
}
